module.exports = __webpack_public_path__ + "img/newsvg.17a6e44e.svg";